export default {
  pages: {
    warehouse: {
      title: 'Склад',
      tabs: ['Офлайн', 'На модерации', 'Онлайн'],
      addManually: 'Добавить вручную',
    },
  },
};
